import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const DownArrowIcon = withSvgIcon(
    <g>
        <polygon points="59.6,126.3 249,315.7 438.4,126.3 466.7,154.6 249,372.3 31.3,154.5 	" />
    </g>
);
